"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoyaltyBonuses = void 0;
var public_api_1 = require("@l2p/public-api");
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var CURRENT_CURRENCY = 'current_currency_by_type';
var CURRENT_LANG = 'current_lang';
var CURRENT_AUTH = 'current_auth';
var useLoyaltyBonuses = function () {
    var isAuth = (0, user_1.useIsAuthorized)();
    var _a = (0, useCache_1.useCache)(), getDataFromCache = _a.getDataFromCache, setDataToCache = _a.setDataToCache;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var lang = (0, next_intl_1.useLocale)();
    var _b = (0, useQuery_1.useQuery)({
        // canRender: isAuth,
        path: keys_1.LOYALTY_BONUSES,
        payload: { bonusType: public_api_1.BonusType.Loyality, currency: currentCurrency, lang: lang },
        revalidateOnMount: true,
        shouldRetryOnError: false,
    }), data = _b.data, error = _b.error, isLoading = _b.isLoading, mutate = _b.mutate;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        var prevLang = getDataFromCache(CURRENT_LANG);
        var prevAuth = getDataFromCache(CURRENT_AUTH);
        if (!prevCurrency ||
            prevCurrency !== currentCurrency ||
            !prevLang ||
            prevLang !== lang ||
            prevAuth !== isAuth) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
            setDataToCache(CURRENT_LANG, lang);
            setDataToCache(CURRENT_AUTH, isAuth);
        }
    }, [lang, getDataFromCache, setDataToCache, currentCurrency, mutate, isAuth]);
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error]);
};
exports.useLoyaltyBonuses = useLoyaltyBonuses;
